import { render } from "./InsanBedeni.vue?vue&type=template&id=9b14a22a&scoped=true"
import script from "./InsanBedeni.vue?vue&type=script&lang=js"
export * from "./InsanBedeni.vue?vue&type=script&lang=js"

import "./InsanBedeni.vue?vue&type=style&index=0&id=9b14a22a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\cosku\\OneDrive\\Masaüstü\\DiyetisyenYagmurDemir\\GT Yönetim Sistemi - Kopya\\Yönetim Sistemi - Frontend\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b14a22a"]])

export default __exports__